import { render, staticRenderFns } from "./createprice.vue?vue&type=template&id=3882f0d0&"
import script from "./createprice.vue?vue&type=script&lang=ts&"
export * from "./createprice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createprice.vue"
export default component.exports